module.exports = __webpack_public_path__ + "static/media/logo_integrar.228e8d22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_integrar.png
// module id = 1742
// module chunks = 0